<template>
  <div class="zcbody" v-loading="loading">
    <div class="zc-header">
      <div class="head" style="padding: 20px 0 30px 0">
        <div class="logo">
          <router-link :to="{ path: '/login' }"><img src="../../assets/images/logo.png" style="width: 80px" /></router-link>
        </div>
        <span class="logintext">认养一头牛SRM供应商管理平台</span>
      </div>
    </div>
    <div class="contaner">
      <div class="z_heng">
        <ul>
          <li class="agreement active">
            <img src="../../assets/images/agreement2.png" /><span>注册协议</span>
          </li>
          <li class="information active">
            <img src="../../assets/images/information3.png" /><span>用户信息</span>
          </li>
          <li class="archives active">
            <img src="../../assets/images/archives3.png" /><span>供货信息</span>
          </li>
          <li class="supply-object">
            <img src="../../assets/images/supply-object1.png" /><span>上传资质</span>
          </li>
          <li class="intelligence">
            <img src="../../assets/images/intelligence1.png" /><span>注册完成</span>
          </li>
        </ul>
      </div>
      <div class="protocol-title">供货对象信息</div>
      <div class="protocont">
        <span style="color: #949494" class="prospan">您的供货对象:下列组织机构有哪些符合您的供货目标?您可以参考组织机构所处的地理位置进行选择。</span>

        <el-table ref="multipleTable" :data="GetALLtable" max-height="420" border tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" @row-click="handleRowClick" :header-cell-style="{ textAlign: 'center' }">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="公司名称" prop="cztname"></el-table-column>
          <el-table-column label="公司地址" prop="caddress"></el-table-column>
        </el-table>
      </div>
      <div class="protocol-title">
        供货物资或者服务<span style="color:red;font-size:14px">(只能选择一种物料)</span>
        <el-button size="mini" type="success" class="pull-right" @click="addtable">新增</el-button>
      </div>
      <div class="protocol-accept1">
        <span><b></b></span>
      </div>
      <div class="protocont">
        <el-table ref="suppleTable" :data="suppliestable" border max-height="420" tooltip-effect="dark" style="width: 100%" :header-cell-style="{ textAlign: 'center' }">
          <el-table-column type="index" label="序号" width="55"></el-table-column>
          <el-table-column label="类别名称" prop="cclassname"></el-table-column>
          <el-table-column prop="name" label="操作" width="160">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="del(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="zc_btn">
        <el-button type="success" round @click="prereturn()">上一步</el-button>
        <el-button type="success" round @click="clickSubmit()">下一步</el-button>
      </div>
    </div>
    <tree v-if="treeif" :suppliestable="suppliestable" @supplie="supplie" :treeif="treeif" />
  </div>
</template>

<script>
import tree from "./SupplyObject/tree.vue";

export default {
  components: {
    tree,
  },
  data() {
    return {
      treeif: false,
      loading: false,
      urlid: "",
      GetALLtable: [],
      suppliestable: [],
      comdata: [],
    };
  },
  created() {
    this.urlid = this.$route.query.id;
    this.GetALL();
    this.GetCusInvClass();
  },
  methods: {
    handleRowClick(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    GetCusInvClass() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetCusInvClass",
        data: { KeyValue: this.urlid },
      }).then((res) => {
        console.log(res, "urlid");
        if (res.data.Success) {
          var comdata = eval(res.data.Data.data2);
          comdata = JSON.parse(
            JSON.stringify(comdata)
              .replace(/"cpasturecode"/g, '"cztcode"')
              .replace(/"cpasturename"/g, '"cztname"')
          );
          var list = {};
          for (var a = 0; a < comdata.length; a++) {
            if (comdata[a].caddress) {
              list = {
                cztcode: comdata[a].cztcode,
                cztname: comdata[a].cztname,
                caddress: comdata[a].caddress,
              };
            } else {
              list = {
                cztcode: comdata[a].cztcode,
                cztname: comdata[a].cztname,
              };
            }
            this.comdata.push(list);
          }
          this.suppliestable = res.data.Data.data1;
          this.toggleSelection(this.comdata);
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    toggleSelection(rows) {
      console.log();
      var that = this;
      rows = JSON.parse(JSON.stringify(rows));
      that.$nextTick(() => {
        if (that.$refs.multipleTable) {
          that.$refs.multipleTable.clearSelection();
        }
        var arr = this.GetALLtable;
        rows.forEach((row) => {
          for (let j in arr) {
            if (row.cztcode == arr[j].cztcode) {
              // console.log(row)
              that.$refs.multipleTable.toggleRowSelection(arr[j], true);
              break;
            }
          }
        });
      });
    },

    // 删除
    del(row, index) {
      this.suppliestable.splice(index, 1);
    },
    // 父子传值
    supplie(val, val1) {
      if (val != 1) {
        this.suppliestable = val;
      }
      this.treeif = val1;
    },
    // 返回上一步
    prereturn() {
      this.$router.push({ path: "/useregister", query: { id: this.urlid } });
    },
    handleSelectionChange(val) {
      this.comdata = val;
    },
    //  获取全部公司
    GetALL() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetALL",
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          this.GetALLtable = res.data.Data;
          console.log(this.GetALLtable);
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    addtable() {
      this.treeif = true;
    },
    clickSubmit() {
      var jsondata = eval(this.comdata);
      jsondata = JSON.parse(
        JSON.stringify(jsondata)
          .replace(/"cztcode"/g, '"cpasturecode"')
          .replace(/"cztname"/g, '"cpasturename"')
      );

      if (jsondata.length != 0 && this.suppliestable.length != 0) {
        console.log(JSON.stringify(jsondata));
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/SaveCusSupplyInvClass",
          // headers: {
          //   "Content-Type": "application/x-www-form-urlencoded",
          // },
          data: {
            KeyValue: this.urlid,
            JsonSupply: JSON.stringify(jsondata),
            JsonInvClass: JSON.stringify(this.suppliestable),
          },
        }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.$message.success(res.data.Message);
            this.$router.push({
              path: "/Qualification",
              query: { id: this.urlid },
            });
          } else {
            this.$message.error(res.data.Message);
          }
        });
      } else if (jsondata.length == 0) {
        this.$message.error("请选择供货目标公司");
      } else if (this.suppliestable.length == 0) {
        this.$message.error("请选择物料信息");
      }
    },
    // clickSubmit(){
    //    var jsondata = eval(this.comdata);
    //    jsondata = JSON.parse(
    //             JSON.stringify(jsondata).replace(/"cztcode"/g, '"cpasturecode"').replace(/"cztname"/g, '"cpasturename"')
    //           );
    // if(jsondata.length!=0){
    //  console.log(JSON.stringify(jsondata))
    //   // url: "CommonModule/Op_StoreAndInvoice/SaveInvClass",
    // //  url: "CommonModule/Op_Supplier/SaveCusSupply",
    // this.$axios({
    //         method: "post",
    //         url: "CommonModule/Op_Supplier/SaveCusSupply",
    //         headers: {
    // 	      	'Content-Type': 'application/x-www-form-urlencoded'
    // 	       },
    //         params:{KeyValue:this.urlid,JsonDetail:JSON.stringify(jsondata)},

    //   }).then((res) => {
    //            console.log(res);
    //         if (res.data.Success) {
    //           this.SaveCusInvClass()
    //         } else{
    //           this.$message.error(res.data.Message);
    //         }
    //       })
    // }else{
    //   this.$message.error("请选择供货目标公司")
    // }

    // },
    SaveCusInvClass() {
      if (this.suppliestable.length != 0) {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/SaveCusInvClass",
          params: {
            KeyValue: this.urlid,
            JsonDetail: JSON.stringify(this.suppliestable),
          },
        }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.$router.push({
              path: "/Qualification",
              query: { id: this.urlid },
            });
          } else {
            this.$message.error(res.data.Message);
          }
        });
      } else {
        this.$message.error("请选择物料信息");
      }
    },
  },

  mounted() {},
};
</script>
<style scoped>
@import url(../../assets/css/reg.css);
</style>